// extracted by mini-css-extract-plugin
export default {"controls":"controls--vxiw6RdICb","grow":"grow--Meqa2l-5aJ"};